import { useState } from 'react'
import { ImageIcon } from 'lucide-react'

/**
 * Miniatura de una herramienta para los listados.
 *
 * El nombre solo no basta para distinguirlas: en el almacén hay varios
 * taladros y varias esmeriladoras, y en una tabla larga se confunden.
 *
 * **Solo fotos de la herramienta** (`photoUrl1..3`), nunca evidencias. Las
 * evidencias cuelgan de un movimiento y retratan una entrega o un daño
 * concreto, no el equipo: una herramienta en buen estado saldría en el listado
 * con la foto del golpe que se reportó una vez.
 */
export const MiniaturaHerramienta = ({
  foto,
  alt,
  lado = 36,
}: {
  foto: string | null
  alt: string
  /** Lado del cuadro en píxeles. */
  lado?: number
}) => {
  // Una URL guardada puede quedar rota si el archivo ya no está en el storage.
  // Sin esto el navegador deja el ícono de imagen partida, que se ve peor que
  // el marcador de posición.
  const [fallo, setFallo] = useState(false)
  const estilo = { width: lado, height: lado }

  if (!foto || fallo) {
    return (
      <div
        className="rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0"
        style={estilo}
        aria-hidden="true"
      >
        <ImageIcon className="w-4 h-4 text-gray-300" />
      </div>
    )
  }

  return (
    <div
      className="rounded-lg overflow-hidden border border-gray-200 bg-gray-50 flex-shrink-0"
      style={estilo}
    >
      <img
        src={foto}
        alt={alt}
        loading="lazy"
        onError={() => setFallo(true)}
        className="w-full h-full object-cover"
      />
    </div>
  )
}
